"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.init = init;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _netUtils = require("@onviobr/net-utils");

var _constants = require("../utils/constants");

var _2 = require(".");

var deregister;

function init() {
  var _context;

  var domainAllowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (deregister) {
    deregister();
  }

  deregister = (0, _netUtils.injectHeaders)({
    'Accept-Language': function AcceptLanguage(_, headersOrReq, headersOrNone) {
      var headers = headersOrNone || headersOrReq;
      return headers['accept-language'] || headers['Accept-Language'] || (0, _2.getCurrentLanguage)();
    }
  }, (0, _concat.default)(_context = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context, (0, _toConsumableArray2.default)(domainAllowList)));
  return function () {
    if (deregister) {
      deregister();
      deregister = null;
    }
  };
}
